import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../Icons'

import ParkingInfoSection from './components/ParkingInfoSection'

const ParkingVehicleInfo = ({ vehicleData }) => {
  const { t } = useTranslation(['parking'])
  return (
    <ParkingInfoSection title={t('parking:vehicleInfo.title')}>
      <div className="parking-info__section-separator" />
      <div className="parking-info__vehicle-info-phone">
        <Icon icon="phone" />
        {vehicleData.phone}
      </div>
      <div className="parking-info__section-separator" />

      <div className="parking-info__vehicle-info-row">
        <div className="parking-info__vehicle-info-item">
          <div className="parking-info__vehicle-info-item-key">
            {t('parking:vehicleInfo.plateNumber')}
          </div>
          <div className="parking-info__vehicle-info-item-value">{vehicleData.plate}</div>
        </div>
        <div className="parking-info__vehicle-info-item">
          <div className="parking-info__vehicle-info-item-key">
            {t('parking:vehicleInfo.color')}
          </div>
          <div className="parking-info__vehicle-info-item-value">{vehicleData.color}</div>
        </div>
      </div>
      <div className="parking-info__section-separator" />

      <div className="parking-info__vehicle-info-row">
        <div className="parking-info__vehicle-info-item">
          <div className="parking-info__vehicle-info-item-key">{t('parking:vehicleInfo.make')}</div>
          <div className="parking-info__vehicle-info-item-value">{vehicleData.make}</div>
        </div>
        <div className="parking-info__vehicle-info-item">
          <div className="parking-info__vehicle-info-item-key">
            {t('parking:vehicleInfo.model')}
          </div>
          <div className="parking-info__vehicle-info-item-value">{vehicleData.model}</div>
        </div>
      </div>
      <div className="parking-info__section-separator" />
    </ParkingInfoSection>
  )
}

ParkingVehicleInfo.propTypes = {
  vehicleData: PropTypes.object,
}

export default ParkingVehicleInfo
